import React from 'react';

interface ViewInfoBannerProps {
  viewParam: string | null;
}

const ViewInfoBanner: React.FC<ViewInfoBannerProps> = ({ viewParam }) => {
  if (viewParam === 'permissions') {
    return (
      <div className="mb-6 rounded-lg border border-blue-500/30 bg-blue-500/10 px-4 py-3 text-sm text-blue-200">
        <div className="flex items-start space-x-3">
          <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p className="font-semibold">Gestion des permissions</p>
            <p className="text-sm mt-1">Consultez ci-dessous la liste complète des utilisateurs avec leurs rôles et permissions. Vous pouvez voir le rôle de chaque utilisateur dans la colonne "Rôle".</p>
          </div>
        </div>
      </div>
    );
  }

  if (viewParam === 'assign') {
    return (
      <div className="mb-6 rounded-lg border border-cockpit-violet/30 bg-cockpit-violet/10 px-4 py-3 text-sm text-cockpit-violet">
        <div className="flex items-start space-x-3">
          <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p className="font-semibold">Attribution de rôles</p>
            <p className="text-sm mt-1">Pour attribuer ou modifier un rôle, cliquez sur l'icône <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg> dans la colonne "Actions" pour ouvrir le formulaire de changement de rôle.</p>
          </div>
        </div>
      </div>
    );
  }

  if (viewParam === 'access') {
    return (
      <div className="mb-6 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-200">
        <div className="flex items-start space-x-3">
          <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p className="font-semibold">Gérer les accès aux pages du panel</p>
            <p className="text-sm mt-1">Vous pouvez donner ou retirer l'accès à des sections spécifiques du panel (Administration, Modération, Statistiques, etc.) indépendamment du rôle de l'utilisateur. Cliquez sur l'icône <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg> dans la colonne "Actions" pour gérer les accès aux pages du panel.</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ViewInfoBanner;

